<div
  id="app-feedback-attempt"
  class="container d-flex flex-column flex-grow-1 pt-5 pb-2 px-2 h-100"
  role="main"
  [attr.aria-label]="('FEEDBACKDISPLAY' | translate)"
>
  <div class="custom-scrollbar overflow-y-auto mb-3">
    @if (missingContext()) {
      <div class="card mb-3">
        <div class="card-body p-card text-center">
          <app-headline
            [title]="'FEEDBACKNORESULTSFORCURRENTFILTER' | translate"
            [type]="'h6'"
            [class]="'text-secondary'"
          ></app-headline>
          <div class="mt-3">
            <app-form-button
              [text]="'BACK' | translate"
              [cssClass]="'e-primary e-small fs-default fw-semibold'"
              (click)="navigateBack()"
            ></app-form-button>
          </div>
        </div>
      </div>
    } @else if (context()?.loading) {
      <div class="card mb-3">
        <div class="card-body p-card text-center">
          <app-headline
            [title]="'LOADING' | translate"
            [type]="'h6'"
            [class]="'text-secondary'"
          ></app-headline>
        </div>
      </div>
    } @else if (context()?.loadError || presentation() === null || !formControlsReady()) {
      <div class="card mb-3">
        <div class="card-body p-card text-center">
          <app-headline
            [title]="context()?.loadError ? ('FEEDBACKNORESULTSFORCURRENTFILTER' | translate) : ('LOADING' | translate)"
            [type]="'h6'"
            [class]="'text-secondary'"
          ></app-headline>
        </div>
      </div>
    } @else {
      @if (completionVisible()) {
        <app-feedback-attempt-completion
          [completion]="presentation()?.completion ?? null"
          [questions]="questions()"
          [completionResult]="context()?.completion?.result ?? null"
          [evaluations]="context()?.completion?.evaluations ?? []"
          [showReturnButton]="true"
          (returnSelected)="navigateBack()"
        ></app-feedback-attempt-completion>
      } @else {
      @if (!isOneByOne() || shouldShowOneByOneIntro()) {
        <div class="card mb-3">
          <div class="card-body p-card">
            <div class="my-3 text-center">
              <div class="no-content-large-icon bg-primary rounded-circle d-flex justify-content-center align-items-center mx-auto">
                <app-icon-badge
                  [style]="'default'"
                  [icon]="'cycle'"
                  [fontSize]="'fs-3'"
                  [fontColor]="'text-white'"
                ></app-icon-badge>
              </div>
              <div class="mt-3">
                <app-headline
                  [title]="presentation()!.title"
                  [type]="'h5'"
                  [class]="'card-title'"
                ></app-headline>
              </div>
            </div>

            <div class="d-flex flex-column p-3 mt-3 mb-3">
              @if (presentation()!.description !== null && presentation()!.description !== '') {
                <div class="mt-2">
                  <app-content
                    [type]="'richtext'"
                    [expandable]="false"
                    [innerHTML]="presentation()!.description ?? ''"
                  ></app-content>
                </div>
              }
              @if (presentation()!.files.length > 0) {
                <div class="d-flex justify-content-end align-items-center mt-3">
                  <app-form-button
                    [text]="'SHOWATTACHMENTS' | translate"
                    [cssClass]="'e-btn e-flat fw-bold fs-small text-muted p-1'"
                    [icon]="'attach_file'"
                    [iconPosition]="'left'"
                    [iconClass]="'fs-5'"
                    [hideTextOnMobile]="false"
                    (click)="displayAttachmentsDialog.set(true)"
                  ></app-form-button>
                </div>
              }
            </div>
          </div>
          @if (shouldShowOneByOneIntro() && displayedQuestions().length > 0) {
            <div class="card-footer">
              <div class="d-flex justify-content-end">
                <app-form-button
                  [text]="'NEXT' | translate"
                  [type]="'button'"
                  [cssClass]="'e-primary ms-auto w-25 min-w-auto'"
                  (click)="startOneByOneFlow()"
                ></app-form-button>
              </div>
            </div>
          }
        </div>
      }

      @if (shouldShowQuestionForm()) {
        <form [formGroup]="attemptForm" (ngSubmit)="submitAttempt()">
          @if (isOneByOne()) {
            <div class="card mb-3">
              <div class="card-body p-card">
                @if (activeOneByOneQuestion(); as activeQuestion) {
                  @for (question of [activeQuestion]; track question.id ?? question.position) {
                    <div id="feedback-attempt-active-one-by-one-question" tabindex="-1">
                      <app-feedback-question-wrapper
                        [question]="question"
                        [allQuestions]="questions()"
                        [questionNumber]="activeOneByOneQuestionNumber()"
                        [formGroup]="attemptForm"
                        [presentationClass]="displayClass()"
                        [controlNamePrefix]="controlNamePrefix"
                        [showAffectedRuleIcon]="false"
                        [showRequiredAnswerError]="hasRequiredAnswerError(question)"
                        [disabled]="activeOneByOneQuestionLocked()"
                      ></app-feedback-question-wrapper>
                    </div>
                  }
                } @else {
                  <div class="text-center">
                    <app-headline
                      [title]="'FEEDBACKQUESTIONNOTITLEANDDESCRIPTION' | translate"
                      [type]="'h6'"
                      [class]="'text-secondary'"
                    ></app-headline>
                  </div>
                }
              </div>
              <div class="card-footer">
                <div class="d-flex justify-content-between align-items-center gap-3 flex-wrap">
                  @if (hasActiveOneByOneTimer()) {
                    <div
                      class="d-flex align-items-center gap-2 flex-shrink-0"
                      aria-live="polite"
                      [attr.aria-label]="('FEEDBACKTIMELEFTTOANSWER' | translate) + ': ' + activeOneByOneTimerText()"
                    >
                      <app-headline
                        [type]="'h6'"
                        [class]="'text-primary fw-bold mb-0'"
                        [title]="'FEEDBACKTIMELEFTTOANSWER' | translate"
                      ></app-headline>
                      <app-headline
                        [type]="'h5'"
                        [class]="oneByOneQuestionExpired() ? 'text-danger fw-bold mb-0' : 'text-primary fw-bold mb-0'"
                        [title]="activeOneByOneTimerText()"
                      ></app-headline>
                    </div>
                  }
                  <div id="feedback-attempt-one-by-one-action" class="d-flex justify-content-end flex-grow-1">
                  @if (activeOneByOneQuestion() !== null && !isLastOneByOneQuestion()) {
                    <app-form-button
                      [text]="'NEXT' | translate"
                      [type]="'button'"
                      [cssClass]="'e-primary w-25 min-w-auto'"
                      [disabled]="!canAdvanceOneByOne()"
                      (click)="showNextQuestion()"
                    ></app-form-button>
                  } @else {
                    <button
                      type="submit"
                      class="e-primary w-25 min-w-auto e-control e-btn e-lib"
                      [disabled]="!canAdvanceOneByOne()"
                      [attr.aria-label]="'FINISH' | translate"
                    >
                      <span class="px-1">{{ 'FINISH' | translate }}</span>
                    </button>
                  }
                  </div>
                </div>
              </div>
            </div>
          } @else {
            <div class="card mb-3">
              <div class="card-body p-card">
                @for (question of displayedQuestions(); track question.id ?? question.position; let questionIndex = $index) {
                  <app-feedback-question-wrapper
                    [question]="question"
                    [allQuestions]="questions()"
                    [questionNumber]="questionIndex + 1"
                    [formGroup]="attemptForm"
                    [presentationClass]="displayClass()"
                    [controlNamePrefix]="controlNamePrefix"
                    [showAffectedRuleIcon]="false"
                    [showRequiredAnswerError]="hasRequiredAnswerError(question)"
                  ></app-feedback-question-wrapper>
                } @empty {
                  <div class="text-center">
                    <app-headline
                      [title]="'FEEDBACKQUESTIONNOTITLEANDDESCRIPTION' | translate"
                      [type]="'h6'"
                      [class]="'text-secondary'"
                    ></app-headline>
                  </div>
                }
              </div>
              <div class="card-footer">
                <div class="d-flex justify-content-end">
                  <button
                    type="submit"
                    class="e-primary ms-auto w-25 min-w-auto e-control e-btn e-lib"
                    [disabled]="!canFinishAttempt()"
                    [attr.aria-label]="'FINISH' | translate"
                  >
                    <span class="px-1">{{ 'FINISH' | translate }}</span>
                  </button>
                </div>
              </div>
            </div>
          }
        </form>
      }
      }
    }
  </div>
</div>

@if (displayAttachmentsDialog() && presentation() !== null) {
  <app-dialog-documents-attachments
    [visible]="displayAttachmentsDialog()"
    (visibleChange)="displayAttachmentsDialog.set($event)"
    [files]="presentation()!.files"
  ></app-dialog-documents-attachments>
}
